<template>
  <div>
    <div class="customers-page">
      <!-- Show filter button for non-admin users on mobile/tablet/laptop -->
      <div
        v-if="getUserRole?.userroll !== 'admin' && (isMobile || isTablet || isLaptop)"
        class="filter-section d-flex flex-row"
        style="gap: 10px; align-items: center; margin-bottom: 10px;"
      >
        <FilterButton mode="customers" />
      </div>
      
      <CustomersTable
        @getCustomersPagination="getCustomersPagination"
        :customersList="getCustomers"
        :count="getCountCustomers"
        :customerInAppCount="getCustomerInAppCount"
        :customersMadeOrdersWeekAgo="getCustomersMadeOrdersWeekAgo"
      />
    </div>
  </div>
</template>

<script>
import CustomersTable from "../helpers/CustomersTable.vue";
import FilterButton from "../helpers/FilterButton.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    CustomersTable,
    FilterButton,
  },
  data() {
    return {};
  },
  // watch: {
  //   "$route.query"() {
  //     this.initFilter();
  //   },
  //   "$route.params"() {
  //     this.initFilter();
  //   },
  // },
  // mounted() {
  //   this.initFilter();
  // },
  methods: {
    async getCustomersPagination(obj) {
      await this.$store.dispatch("Customers/getCustomersPagination", obj);
      // this.initFilter();
    },
    // initFilter() {
    //   this.filteredCustomerList = this.getCustomers;
    //   const categoriesKeys = Object.keys(this.$route.query);
    //   const paramsKeys = Object.keys(this.$route.params);

    //   for (let categoryKey of categoriesKeys) {
    //     this.filterCustomers(categoryKey, this.$route.query[categoryKey]);
    //   }

    //   for (let paramKey of paramsKeys) {
    //     this.filterCustomers(paramKey, this.$route.params[paramKey]);
    //   }
    // },
    // filterCustomers(categoryKey, categoryValue) {
    //   let filteredCustomers = this.filteredCustomerList;
    //   let newFilteredCustomers = [];
    //   newFilteredCustomers = filteredCustomers.filter((cust) => {
    //     let isFiltered = false;

    //     switch (categoryKey) {
    //       case "distLine":
    //         isFiltered = cust.DistLine.linekey === parseInt(categoryValue);
    //         break;
    //       case "agentId":
    //         isFiltered = cust.Agent.agent === parseInt(categoryValue);
    //         break;
    //       case "custId":
    //         isFiltered = cust.cust === parseInt(categoryValue);
    //         break;
    //       case "status":
    //         isFiltered = (cust.isActive ? 1 : 0) === parseInt(categoryValue);
    //         break;
    //       case "custType":
    //         if (categoryValue === "allcustomers") {
    //           isFiltered = true;
    //         } else if (categoryValue === "appcustomers") {
    //           isFiltered = cust.isInApp;
    //         }
    //         break;
    //     }
    //     return isFiltered;
    //   });
    //   this.filteredCustomerList = newFilteredCustomers;
    // },
  },
  computed: {
    ...mapGetters({
      getCustomers: "Customers/getCustomers",
      getCustomerInAppCount: "Customers/getCustomerInAppCount",
      getCustomersMadeOrdersWeekAgo: "Customers/getCustomersMadeOrdersWeekAgo",
      // getCustomersDistLines: "Customers/getCustomersDistLines",
      getCountCustomers: "Customers/getCustomersCount",
      getUserRole: "AuthModule/getUserRole",
      isMobile: "isMobile",
      isTablet: "isTablet", 
      isLaptop: "isLaptop",
    }),
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/globalVariables.scss';

//style for page with scope
.customers-page {
  padding: 15px !important;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@include media(mobile) {
  .button-container {
    gap: 10px;
    margin-bottom: 20px !important;
    flex-direction: column !important;
  }

  .customers-page {
    padding: 10px !important;
    margin-top: 10px !important;
    width: 100vw;
    // max-width: calc(100vw - 40px);
  }
  .mobile-nav-buttons {
    // margin-right: 15px;
  }
  .date-filters {
    gap: 20px !important;
  }
}

.customers-page {
  margin-top: 20px;
}

@include media(tablet,  ) {
  .customers-page {
    padding: 0px !important;
    margin-top: 0px !important;
  }
}


.modal-content {
  font-size: $mediumTextSize;
  color: $modalContentColor;
  font-weight: 400;
  line-height: 21.33px;
  text-align: center;
  margin-top: -20px;

  .email {
    color: #36b079;
  }
}
.finances-page {
  margin-right: 20px;
  padding-bottom: 50px;
  padding-right: 40px;
  padding-left: 40px;
}

.date-filters {
  display: flex;
  gap: 40px;
}
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
}
</style>
